<template>
  <div>
    <div class="box-content-pagination">
      <template v-if="is_desktop">
        <span v-if="showPagingInfo" class="pagination-info" v-html="pagingInfo"></span>
      </template>
      <div v-if="showPaging" class="pagination-wrapper">
        <a
          href=""
          class="pagination-navigation fa fa-angle-double-left pagination-navigation-first"
          :class="{ disabled: showFirstNavigation }"
          @click.prevent="firstNavigation"
        >
        </a>
        <a
          href=""
          class="pagination-navigation fa fa-angle-left pagination-navigation-prev"
          :class="{ disabled: !showPrevNavigation }"
          @click.prevent="prevNavigation"
        >
        </a>
        <ul class="pagination">
          <template v-if="activeNumberPagination > maxPaginationNumber">
            <li
              class="pagination__number"
              :class="{ active: activeNumberPagination === 1 }"
              @click.prevent="skipTo({ number: 1 })"
            >
              1
            </li>
            <li class="pagination__number" @click.prevent="skipTo({ number: startLoopForShowNumberPagination })">
              ...
            </li>
          </template>

          <li
            v-for="(pagination, key) in listPagination"
            :key="key"
            class="pagination__number"
            :class="{
              active: activeNumberPagination === pagination.number,
              hidden: pagination.isHidden,
            }"
            @click.prevent="skipTo(pagination)"
          >
            {{ pagination.number }}
          </li>

          <template v-if="totalPagination > maxPaginationNumber && showRestNextPagination">
            <li class="pagination__number" @click.prevent="skipTo({ number: endLoopForShowNumberPagination + 1 })">
              ...
            </li>
            <li
              class="pagination__number"
              :class="{ active: activeNumberPagination === totalPagination }"
              @click.prevent="skipTo({ number: totalPagination })"
            >
              {{ totalPagination }}
            </li>
          </template>
        </ul>
        <a
          href=""
          class="pagination-navigation fa fa-angle-right pagination-navigation-next"
          :class="{ disabled: !showNextNavigation }"
          @click.prevent="nextNavigation"
        ></a>
        <a
          href=""
          class="pagination-navigation fa fa-angle-double-right pagination-navigation-last"
          :class="{ disabled: showLastNavigation }"
          @click.prevent="lastNavigation"
        ></a>
      </div>
      <template v-if="!is_desktop">
        <span v-if="showPagingInfo" class="pagination-info" v-html="pagingInfo"></span>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    limit: {
      required: true,
    },
    showPagingInfo: {
      default: false,
      type: Boolean,
    },
    removePagingIfOnlyOnePresent: {
      default: true,
      type: Boolean,
    },
    skip: {
      required: true,
    },
    totalItem: {
      required: true,
    },
    customInfo: {
      required: false,
      type: Boolean,
    },
  },
  data() {
    return {
      activeNumber: 1,
      endLoopForShowNumberPagination: null,
      listPagination: '',
      loopNumbers: 0,
      // maxPaginationNumber: 3,
      restPaginationNumber: '',
      startLoopForShowNumberPagination: null,
      totalPagination: 0,
    };
  },
  computed: {
    is_desktop() {
      return this.$store.state.screen.isDesktop;
    },
    pagingInfo() {
      const { from, to, totalItem } = this;
      let result = '';
      if (this.$store.state.screen.isDesktop) {
        result = `${from} - ${to > totalItem ? totalItem : to} <span>dari</span> ${totalItem}`;
      } else {
        result = `Menampilkan ${from} - ${to > totalItem ? totalItem : to} <span>dari</span> ${totalItem} produk`;
      }
      return result;
    },
    showPaging() {
      if (!this.removePagingIfOnlyOnePresent) {
        return true;
      }

      return this.listPagination.length > 1;
    },
    showNextNavigation() {
      return this.listPagination.length > 1 && this.activeNumberPagination < this.totalPagination;
    },
    showPrevNavigation() {
      return this.listPagination.length > 1 && this.activeNumberPagination > 1;
    },
    showFirstNavigation() {
      return this.activeNumberPagination === 1;
    },
    showLastNavigation() {
      return this.totalPagination === this.activeNumberPagination;
    },
    activeNumberPagination() {
      return parseInt(this.$route.query.page) || this.activePagination || 1;
    },
    showRestNextPagination() {
      if (this.totalPagination === this.endLoopForShowNumberPagination) {
        return false;
      }
      return this.activeNumberPagination <= this.totalPagination - (this.totalPagination % this.maxPaginationNumber);
    },
    from() {
      return this.skip + 1;
    },
    to() {
      return this.activeNumberPagination * this.limit;
    },
    maxPaginationNumber() {
      if (this.activeNumberPagination > 5) {
        return 5;
      } else {
        const addMaxPaginationNumber = this.activeNumberPagination - 1;
        return 3 + addMaxPaginationNumber;
      }
    },
  },
  watch: {
    activeNumberPagination() {
      if (this.activeNumberPagination) {
        this.generatedListPagination();
      }
    },
    totalItem() {
      if (this.totalItem) {
        this.generatedListPagination();
      }
    },
    limit() {
      if (this.limit) {
        this.generatedListPagination();
      }
    },
  },
  created() {
    this.generatedListPagination();
  },
  methods: {
    generatedListPagination() {
      const tempListPagination = [];
      let i;

      this.totalPagination = Math.ceil(this.totalItem / this.limit);
      // this.activeNumberPagination = (this.skip / this.limit) + 1

      const endLoopForShowNumberPagination =
        Math.ceil(this.activeNumberPagination / this.maxPaginationNumber) * this.maxPaginationNumber;

      const startLoopForShowNumberPagination = endLoopForShowNumberPagination - this.maxPaginationNumber;

      for (i = 1; i <= this.totalPagination; i++) {
        const tempObjPagination = {
          number: i,
          isHidden: true,
        };

        if (i > startLoopForShowNumberPagination && i <= endLoopForShowNumberPagination) {
          tempObjPagination.isHidden = false;
        }

        tempListPagination.push(tempObjPagination);
      }

      this.endLoopForShowNumberPagination = endLoopForShowNumberPagination;
      this.startLoopForShowNumberPagination = startLoopForShowNumberPagination;
      this.listPagination = tempListPagination;
    },
    nextNavigation() {
      if (this.activeNumberPagination < this.totalPagination) {
        this.skipTo({ number: this.activeNumberPagination + 1 });
      }
    },
    firstNavigation() {
      if (this.activeNumberPagination > 1) {
        this.skipTo({ number: 1 });
      }
    },
    prevNavigation() {
      if (this.activeNumberPagination > 1) {
        this.skipTo({ number: this.activeNumberPagination - 1 });
      }
    },
    lastNavigation() {
      if (this.activeNumberPagination < this.totalPagination) {
        this.skipTo({ number: this.totalPagination });
      }
    },
    regeneratedListPagination() {
      let newEndLoopForShowNumberPagination;
      let newStartLoopForShowNumberPagination;

      newEndLoopForShowNumberPagination =
        Math.ceil(this.activeNumberPagination / this.maxPaginationNumber) * this.maxPaginationNumber;

      newEndLoopForShowNumberPagination =
        newEndLoopForShowNumberPagination < this.totalPagination
          ? newEndLoopForShowNumberPagination
          : this.totalPagination;

      newStartLoopForShowNumberPagination = newEndLoopForShowNumberPagination - this.maxPaginationNumber;
      newStartLoopForShowNumberPagination =
        newStartLoopForShowNumberPagination >= 0 ? newStartLoopForShowNumberPagination : 0;

      if (this.listPagination[newStartLoopForShowNumberPagination].isHidden) {
        // show number list
        for (let i = newStartLoopForShowNumberPagination; i < newEndLoopForShowNumberPagination; i++) {
          this.listPagination[i].isHidden = false;
        }

        // end number list
        for (let i = this.startLoopForShowNumberPagination; i < this.endLoopForShowNumberPagination; i++) {
          if (this.listPagination[i] && Object.keys(this.listPagination[i])) {
            this.listPagination[i].isHidden = true;
          }
        }

        // re assign
        this.startLoopForShowNumberPagination = newStartLoopForShowNumberPagination;
        this.endLoopForShowNumberPagination = newEndLoopForShowNumberPagination;
      }
    },
    skipTo(pagination) {
      this.activeNumber = pagination.number;
      this.$emit('skipTo', pagination);
    },
  },
};
</script>
